export enum TTableOptionAction {
  HeaderClick = 1,
  Download,
  View,
  OnlyText,
  Edit,
  Delete,
  Route,
}
